import Api from "./Api";

export default {
    getAllCopyAWS(payload) {
        let AllCopAWSList = Api().get("copyAWSFiles.php?upload_dir_folderName="+payload);
        return AllCopAWSList;
    },
    getAllAccountList(payload) {
        let AllExpenseList = Api().post(
            "Api_Expenses/allExpenses.php",
            payload
        );
        return AllExpenseList;
    },
    getAllCBList(payload) {
        let AllExpenseList = Api().post(
            "Api_ConsoleBooking/viewAllconsoleBookingList.php",
            payload
        );
        return AllExpenseList;
    },
    getAllContractList(payload) {
        let AllExpenseList = Api().post(
            "Api_ConsoleBooking/getContractDetails.php",
            payload
        );
        return AllExpenseList;
    },
    getAllPrerequisiteList(payload) {
        let AllExpenseList = Api().post(
            "Api_Consolidation/getPrerequisite.php",
            payload
        );
        return AllExpenseList;
    },
    getAllClientKycList(payload) {
        let AllClientKycList = Api().post(
            "Api_ClientUser/getClientKyc.php",
            payload
        );
        return AllClientKycList;
    },
};



// WEBPACK FOOTER //
// ./src/services/AccountService.js